import { type ReactNode } from 'react';

interface PageHeaderRowProps {
  title: string;
  description?: string;
  rightContent?: ReactNode;
  className?: string;
}

export function PageHeaderRow({
  title,
  description,
  rightContent,
  className = '',
}: PageHeaderRowProps) {
  return (
    <div className={`page-top-row ${className}`.trim()}>
      <div className="page-top-row__left">
        <h2 className="page-top-row__title">{title}</h2>
        {description && <p className="page-top-row__description">{description}</p>}
      </div>
      {rightContent ? <div className="page-top-row__right">{rightContent}</div> : null}
    </div>
  );
}

export default PageHeaderRow;
